// extracted by mini-css-extract-plugin
export var danger = "_2l-6";
export var lightPink = "_2l-a";
export var medium = "_2l-j";
export var nearSquare = "_2l-m";
export var neutralBlue = "_2l-8";
export var neutralYellow = "_2l-7";
export var noCapitalize = "_2l-1";
export var normal = "_2l-2";
export var pill = "_2l-0";
export var primary = "_2l-3";
export var primaryLight = "_2l-4";
export var shadow = "_2l-n";
export var small = "_2l-k";
export var solidBlack = "_2l-i";
export var solidGreen = "_2l-d";
export var solidLightBlue = "_2l-f";
export var solidNavy = "_2l-e";
export var solidOrange = "_2l-h";
export var solidPink = "_2l-g";
export var solidRed = "_2l-b";
export var solidWhite = "_2l-9";
export var solidYellow = "_2l-c";
export var success = "_2l-5";
export var xsmall = "_2l-l";